import styled from 'styled-components';

import { border1, exactWhite, green } from 'utils/style/colors';

import Icon from 'components/Icon';
import { ChipProgress } from 'components/AssigneeChip/AssigneeChip';

type CellProps = {
  bgColor?: string;
};

export const Cell = styled('td')<CellProps>`
  border-radius: 10px;
  text-align: center;
  position: relative;
  padding: 5px 10px;
  background-color: ${(props) =>
    props.bgColor ? props.bgColor + ' !important' : 'white'};
`;
export const HeaderRow = styled('th')<CellProps>`
  border-radius: 10px;
  border: ${border1};
  text-align: center;
  padding: 5px 10px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : exactWhite)};
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: middle;
  min-width: 5rem;
  max-width: 14rem;

  position: sticky;
  top: 0;
  z-index: 2;
`;

export const CornerHeader = styled('th')`
  position: sticky;
  top: 0;
  right: 0;
  z-index: 4;
  background-color: ${exactWhite};
`;

export const HeaderColumn = styled(HeaderRow)<CellProps>`
  position: sticky;
  right: 0;
  z-index: 3;
  text-align: right;
  min-width: 10rem;
  max-width: 22rem;
`;
export const HeaderColumnPrint = styled(HeaderRow)<CellProps>`
  max-width: none;
`;

export const Badge = styled('div')<CellProps>`
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : 'var(--exact-white)'};
  color: ${(props) => (props.bgColor === '#D74242' ? 'white' : 'black')};
  padding: 3px 10px;
  border-radius: 10px;
  white-space: nowrap;
  font-size: 0.8em;
`;

export const TargetRow = styled('div')`
  border-right: 2px solid ${green};
  padding-right: 0.8rem;
  margin: 0.5rem 0;
`;

export const TargetIcon = styled(Icon)`
  margin-left: 1rem;
`;

export const TargetValue = styled(ChipProgress)`
  min-width: 2rem;
  width: auto;
`;

export const TotalPercentageValue = styled(ChipProgress)<CellProps>`
  min-width: 2rem;
  width: auto;
  color: ${(props) => (props.bgColor === '#D74242' ? 'white' : 'black')};
  background-color: ${(props) => props.bgColor};
`;

export const TRTH = styled.tr``;
